import { cn } from '@/lib/utils';

export default function Toolbar({ children }) {
  return (
    <div
      className={cn(
        'fixed left-64 right-0 top-14 px-8 py-3 z-10 min-h-[65px]',
        'border-b shadow-sm',
        'bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80'
      )}
    >
      <div className="flex items-center justify-between">{children}</div>
    </div>
  );
}
